import ContentConfig from '../config/ContentConfig';
import PlaybackConfig from '../config/PlaybackConfig';
import { dispatchBitrateRangeEvent } from '../events/dispatch';
import { PlayType } from '@kollective-frontend/ksdk-api';

const validateBitrate = (data?: number): number | undefined => {
  if (typeof data !== 'number' || data <= 0) {
    return undefined;
  }
  return data;
};

const sendBitrateRangeEvent = async (
  playType: PlayType,
  config: ContentConfig
): Promise<void> => {
  const key: keyof PlaybackConfig = playType === PlayType.VOD ? 'vod' : 'live';
  const playback = config.playback[key];
  const minVideoBitrate = validateBitrate(playback.minVideoBitrate);
  const maxVideoBitrate = validateBitrate(playback.maxVideoBitrate);
  await dispatchBitrateRangeEvent({ minVideoBitrate, maxVideoBitrate });
};

export default sendBitrateRangeEvent;
